/**
 * This bootstrap file is used for both frontend and backend
 */

import _ from "lodash";
import axios from "axios";
import Swal from "sweetalert2";
import $ from "jquery";
import "popper.js"; // Required for BS4
import "bootstrap";
import "select2";
import datepicker from "bootstrap-datepicker";
import pubsub from "pubsub.js";
import dayjs from "dayjs";
import customParseFormat from 'dayjs/plugin/customParseFormat';
// import treegrid from "jquery-treegrid";

// using customParseFormat plugin
dayjs.extend(customParseFormat);

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

window.$ = window.jQuery = $;
window.dayjs = dayjs;
window.Swal = Swal;
window._ = _; // Lodash
window.datepicker = datepicker; // datepicker
window.pubsub = pubsub;

window.ProgressBar = require('progressbar.js');

// window.treegrid = treegrid;

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require("axios");

window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     encrypted: true
// });
